module.exports = __webpack_public_path__ + "static/media/star-smiley.1ac3c6ee.png";